import styled from 'styled-components';
import { createContext, useState, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUITile = styled.div.withConfig({
  displayName: "CardWrapper__StyledUITile",
  componentId: "oiua4e-0"
})(["", " margin-bottom:", ";border:1px solid ", ";background-color:", ";position:relative;border-radius:", ";box-shadow:", ";"], props => props.theme.typography['detail-200'], props => props.theme.space['100'], props => props.color || props.theme.color['fill-surface-default'], props => props.theme.color['fill-surface-default'], props => props.theme.borderRadius['100'], props => props.theme.boxShadow['100']);
export const StoreContext = /*#__PURE__*/createContext(undefined);
export const CardWrapperContent = ({
  children
}) => {
  const [borderColor, setBorderColor] = useState(undefined);
  const api = useRef({
    setBorderColor
  });
  //@bend-expect trellis-tokenized
  return /*#__PURE__*/_jsx(StyledUITile, {
    "data-test-id": "cdb-card",
    color: borderColor,
    children: /*#__PURE__*/_jsx(StoreContext.Provider, {
      value: api.current,
      children: children
    })
  });
};
export const CardWrapper = ({
  children
}) => {
  return /*#__PURE__*/_jsx(CardWrapperContent, {
    children: children
  });
};